import { useEffect } from "react";
import logo from "../assets/Group (1).svg";

import "@fortawesome/fontawesome-free/css/all.min.css"; // Import FontAwesome CSS
import { Row, Col } from "reactstrap";
// in index.js or App.js
import "bootstrap/dist/css/bootstrap.min.css";
import ".././.././../styles/CommonStyles.css";
import "../styles/LoginStyle.css";
import ResetPasswordLink from "../../forgotPassword/components/ResetPasswordLinkComponent";
import { Routes, Route } from "react-router-dom";
import strings from ".././.././../utils/Strings";
import LoginComponent from "../components/LoginComponent";
import WelcomeComponent from "../components/WelcomeComponent";
import { ApiProvider } from "../../../service/ApiContext";
import { Provider } from "react-redux";
import store from "../../../store/store";
import { useApi } from "../../../service/ApiContext";
import Loader, {
  LocalStorage,
  RegionLocalStorage,
} from "./../../../utils/Utils";
import { useQueryClient } from "react-query";
import { RegionResponse } from "../data/response/RegionResponse";
import LoginClient from "../data/api/LoginClient";
import Logger from "../../../utils/Logger";
import useReCaptchaBadge from "../../../service/UseCaptchaBadge";
import LoginComponentVersionTwo from "../components/LoginComponent";
import ForgotPassword from "../../forgotPassword/components/ForgotPasswordComponent";
import bgImage from "../assets/Subtle Background Gradients.png";
import Signup from "../../registration/pages/SignUpPage";
// import Signup from "../../registration/pages/SignUpPage";

function LoginVersionTwo() {
  // Show only in the production environment
  useReCaptchaBadge();

  const queryClient = useQueryClient();
  const api = useApi();

  useEffect(() => {
    // Push the current state to prevent back navigation
    window.history.pushState(null, "", window.location.href);

    const handlePopState = () => {
      // Re-push the state to prevent going back
      window.history.pushState(null, "", window.location.href);
    };

    window.addEventListener("popstate", handlePopState);

    return () => {
      window.removeEventListener("popstate", handlePopState);
    };
  }, []);
  const fetchRegion = async () => {
    Loader.showLoading("Loading...");

    try {
      // LocalStorage.deleteAllLocalData();
      await new Promise((resolve) => setTimeout(resolve, 2000));
      const response = await api
        .get<RegionResponse>(LoginClient.region)
        .then((res) => {
          const region = res.data.region;
          LocalStorage.setLocalData("region", region);
          Logger.info("region name", res.data.region);
        })
        .catch((error) => {
          Logger.info("error response", error);
        });
    } catch (error) {
      Logger.info("error response", error);
    } finally {
      Loader.dismissLoading();
    }
  };

  useEffect(() => {
    // //Detecting Broswer
    // const browser = CommonUtils.getBrowserInfo();
    // if (browser.type === BrowserType.Safari) {
    //   showAlert({
    //     show: true,
    //     identity: "browserDetection",
    //     title: "Error",
    //     // message: `Detected Browser- ${browser.type} .Not Supported`,
    //     message:
    //       "To ensure all features work as intended, this site requires the latest version of Google Chrome. Please switch to Chrome to continue.",
    //     button1Text: "Cancel",
    //     alertType: "error",
    //     onlyNeedOneButton: false,
    //     btn1onPressed: () => {},
    //   });
    //   return;
    // }
    // if (browser.type === BrowserType.Chrome) {
    //   const chromeVersion = Number(browser.version);

    //   if (chromeVersion < 100) {
    //     showAlert({
    //       show: true,
    //       identity: "browserDetection",
    //       title: "⚠️ Warning",
    //       // message: `Detected Browser - ${browser.type}, Version: ${browser.version}. Not Supported`,
    //       message:
    //         "To ensure all features work as intended, this site requires the latest version of Google Chrome. Please switch to Chrome to continue.",
    //       button1Text: "Cancel",
    //       alertType: "success",
    //       onlyNeedOneButton: true,
    //       btn1onPressed: () => {},
    //     });
    //     return;
    //   }
    // }
    fetchRegion();
    //Removing UseQueryKeys
    queryClient.clear();
  }, []);
  return (
    <Provider store={store}>
      <ApiProvider>
        <div
          className="v2-page-wrapper"
          style={{
            backgroundImage: `url(${bgImage})`,
          }}
        >
          <div className="v2-custom-header">
            <div>
              <img
                src={logo}
                alt="logo"
                style={{
                  height: "80px",
                  width: "140px",
                }}
              />
            </div>
            <div className="v2-rightside-header">
              <a
                href={process.env.REACT_APP_ABOUTUS_URL}
                target="_blank"
                className="v2-rightside-text"
                style={{ textDecoration: "none", color: "black" }}
              >
                About us
              </a>
              <a
                href="https://discovermyskills.jozuna.com/"
                target="_blank"
                className="v2-rightside-text"
                style={{ textDecoration: "none", color: "black" }}
              >
                LMS platform
              </a>{" "}
              <a
                href={process.env.REACT_APP_CONTACTUS_URL}
                target="_blank"
                className="v2-rightside-text"
                style={{ textDecoration: "none", color: "black" }}
              >
                Contact Us
              </a>
            </div>
          </div>

          <div className="v2-login-background">
            <div className="v2-content-wrapper">
              <Row>
                <WelcomeComponent />
                <Col
                  lg={6}
                  style={{
                    display: "flex",
                    justifyContent: "center",
                  }}
                >
                  <Routes>
                    <Route
                      path={strings.routing.loginPage}
                      element={<LoginComponentVersionTwo />}
                    />
                    <Route
                      path={strings.routing.signupPage}
                      element={<Signup />}
                    />
                    <Route
                      path={strings.routing.forgotPasswordpage}
                      element={<ForgotPassword />}
                    />
                    <Route
                      path={strings.routing.resetLinkPage}
                      element={<ResetPasswordLink />}
                    />
                    {/* <Route
                    path={strings.routing.signupPage}
                    element={<Signup />}
                  /> */}
                  </Routes>
                </Col>
              </Row>
            </div>
          </div>
        </div>
      </ApiProvider>
    </Provider>
  );
}

export default LoginVersionTwo;
